var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "entryDesign" },
    [
      _c("div", { staticClass: "formTitle" }, [_vm._v("作品信息提交")]),
      _vm._v(" "),
      _c(
        "el-row",
        { staticClass: "worksSubmitWarp" },
        [
          _c(
            "el-form",
            { attrs: { "label-width": "120px" } },
            [
              _c(
                "el-row",
                [
                  _c(
                    "el-col",
                    { attrs: { span: 15 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "作品 / 课程名称：" } },
                        [
                          _c("el-input", {
                            attrs: { placeholder: "请输入参赛作品/课程名称" },
                            model: {
                              value: _vm.worksModel.workName,
                              callback: function ($$v) {
                                _vm.$set(_vm.worksModel, "workName", $$v)
                              },
                              expression: "worksModel.workName",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-col",
                    { attrs: { span: 15 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "专业大类：" } },
                        [
                          _c(
                            "el-select",
                            {
                              staticStyle: { width: "100%" },
                              attrs: { filterable: "", placeholder: "请选择" },
                              model: {
                                value: _vm.worksModel.majorId,
                                callback: function ($$v) {
                                  _vm.$set(_vm.worksModel, "majorId", $$v)
                                },
                                expression: "worksModel.majorId",
                              },
                            },
                            _vm._l(_vm.majorList, function (item) {
                              return _c("el-option", {
                                key: item.id,
                                attrs: {
                                  label: item.majorName,
                                  value: item.id,
                                },
                              })
                            }),
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _vm.xuanshou
                    ? _c(
                        "el-col",
                        { attrs: { span: 10 } },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { label: "选手名称：" } },
                            [
                              _c(
                                "el-select",
                                {
                                  staticStyle: { width: "100%" },
                                  attrs: {
                                    filterable: "",
                                    placeholder: "请选择选手",
                                  },
                                  model: {
                                    value: _vm.worksModel.userId,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.worksModel, "userId", $$v)
                                    },
                                    expression: "worksModel.userId",
                                  },
                                },
                                [
                                  _c("el-option", { attrs: { value: "" } }, [
                                    _vm._v("请选择选手"),
                                  ]),
                                  _vm._v(" "),
                                  _vm._l(_vm.playerList, function (item) {
                                    return _c("el-option", {
                                      key: item.userId,
                                      attrs: {
                                        label: item.displayName,
                                        value: item.userId,
                                      },
                                    })
                                  }),
                                ],
                                2
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.xuanshou
                    ? _c(
                        "el-col",
                        { attrs: { span: 5 } },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { label: "负责人名称：" } },
                            [
                              _c("el-input", {
                                attrs: {
                                  placeholder: "请输入负责人名称",
                                  disabled: _vm.isName,
                                },
                                model: {
                                  value: _vm.worksModel.userName,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.worksModel, "userName", $$v)
                                  },
                                  expression: "worksModel.userName",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-row",
                { staticClass: "worksBox" },
                _vm._l(_vm.showContentSettingtList, function (item, index) {
                  return _c(
                    "div",
                    { key: index },
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 12 } },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { label: item.name + ":" } },
                            [
                              item.fileType == "input"
                                ? _c("el-input", {
                                    attrs: {
                                      placeholder: "请输入内容",
                                      "show-word-limit": "",
                                    },
                                    model: {
                                      value:
                                        _vm.worksModel
                                          .matchWorksContentParamList[index]
                                          .content,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.worksModel
                                            .matchWorksContentParamList[index],
                                          "content",
                                          $$v
                                        )
                                      },
                                      expression:
                                        "worksModel.matchWorksContentParamList[index].content",
                                    },
                                  })
                                : item.fileType === "url"
                                ? _c("el-input", {
                                    attrs: {
                                      placeholder: "请输入内容",
                                      "show-word-limit": "",
                                    },
                                    model: {
                                      value:
                                        _vm.worksModel
                                          .matchWorksContentParamList[index]
                                          .content,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.worksModel
                                            .matchWorksContentParamList[index],
                                          "content",
                                          $$v
                                        )
                                      },
                                      expression:
                                        "worksModel.matchWorksContentParamList[index].content",
                                    },
                                  })
                                : item.fileType == "textArea"
                                ? _c("el-input", {
                                    attrs: {
                                      type: "textarea",
                                      rows: "8",
                                      maxlength: "150",
                                      "show-word-limit": "",
                                    },
                                    model: {
                                      value:
                                        _vm.worksModel
                                          .matchWorksContentParamList[index]
                                          .content,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.worksModel
                                            .matchWorksContentParamList[index],
                                          "content",
                                          $$v
                                        )
                                      },
                                      expression:
                                        "worksModel.matchWorksContentParamList[index].content",
                                    },
                                  })
                                : _c("UploadWorks", {
                                    attrs: {
                                      imageUrl:
                                        _vm.worksModel
                                          .matchWorksContentParamList[index]
                                          .viewUrl,
                                      title: item.name,
                                      accept: item.fileType,
                                      worksInfo: item,
                                    },
                                    on: {
                                      successUpLoad: function ($event) {
                                        return _vm.getUploadData(
                                          $event,
                                          item.id,
                                          index,
                                          item.fileType
                                        )
                                      },
                                    },
                                  }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                }),
                0
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "submitBtn" },
        [
          _c(
            "el-button",
            {
              attrs: { type: "primary", size: "small" },
              on: {
                click: function ($event) {
                  return _vm.goBack()
                },
              },
            },
            [_vm._v("返回")]
          ),
          _vm._v(" "),
          _vm.isNeedSave
            ? _c(
                "el-button",
                {
                  attrs: { type: "primary", size: "small" },
                  on: {
                    click: function ($event) {
                      return _vm.submitWork(0)
                    },
                  },
                },
                [_vm._v("保存")]
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.isNeedSave
            ? _c(
                "el-button",
                {
                  attrs: { type: "primary", size: "small" },
                  on: {
                    click: function ($event) {
                      return _vm.submitWork(3)
                    },
                  },
                },
                [_vm._v("保存并提交")]
              )
            : _vm._e(),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }